import { fb, validators } from 'form';

export function getCategoryEditModel(data) {

  const model = fb.group({
    categoryName: [data.categoryName || '', [validators.Required()], { type: 'text' }],
  })

  return model;
}
